module.exports = __webpack_public_path__ + "img/19.b430535e.jpg";